import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';

const setup = ({ hasBanner, banner, checkouts }) => {
  if (window.BulldeskSetupInstalled) {
    return;
  }

  window.BulldeskSetupInstalled = true;

  if (!(hasBanner || banner) && !checkouts) {
    return;
  }

  import('../../sass/preflight.css');
  import('tailwindcss/tailwind.css');

  Vue.use(VueCustomElement);

  Vue.customElement(
    'bulldesk-setup',
    () => import('./components/Setup.vue').then((m) => m.default),
    {},
  );

  if (checkouts) {
    Vue.customElement(
      'bulldesk-checkout',
      () =>
        import('./components/Checkout/Checkout.vue').then(
          (m) => m.default,
        ),
      {},
    );

    addIuguOnBody();
  }

  const setup = document.createElement('bulldesk-setup');

  document.body.appendChild(setup);
};

const addIuguOnBody = () => {
  console.log('Create Iugu script...');

  const checkout = document.createElement('script');

  checkout.src = 'https://js.iugu.com/v2';

  document.body.appendChild(checkout);
};

export default setup;
